// extracted by mini-css-extract-plugin
export default {"App":"app_App__YFJAY"};